<template>
    <div class="row">
                            <p>{{ index+1 }}. <span class="questions" v-html="data.question"></span></p>
                            <div class="row" style="margin-top:10px;">
                                <p class="col m3" v-for="item in data.options">
                                    <label>
                                        <input v-bind:name="'group'+index" type="radio"   v-model="choose_data" v-bind:value="item.id"  @change="changeRadio"/>
                                        <span>{{ item.option }}</span>
                                    </label>
                                </p>
                                
                            </div>
                        </div>
</template>
<script>
export default {
    props:["data","index"],
    data() {
        return {
            choose_data: null,
            
        }
    },
    methods: {
        changeRadio()
        {
            
            this.$emit("optionChange",{"question_id":this.data.id,"option_id":this.choose_data})
        }
    },
}
</script>
<style lang="scss" scoped>
    .questions u 
    {
        font-weight:bold;
    }
</style>